/**
 * Barrel file to export all Tailwind component classes in the directory.
 *
 * This file and other *.styles files are using CommonJS module syntax
 * instead of ES6 module syntax because componentStyles is imported into
 * tailwind.config.js.
 *
 * Because component classes are injected before utility classes in the final Tailwind file,
 * any CSS properties defined in component classes can be overriden
 * on a one-off basis by utility classes.
 *
 * If you find yourself often trying to overriding a specific CSS property in a component,
 * it might be time to define that property in the component's ComponentName.styles.js file
 * instead of with a utility class in the ComponentName.jsx file.
 *
 * Documentation reference: https://tailwindcss.com/docs/plugins#adding-components
 */

const { buttonSharedStyles } = require('./Button/buttonShared.styles');
const { checkboxStyles } = require('./Checkbox/Checkbox.styles');
const { circlePrimaryButtonStyles } = require('./Button/CirclePrimaryButton.styles');
const { circleSecondaryButtonStyles } = require('./Button/CircleSecondaryButton.styles');
const { collapseStyles } = require('./Collapse/Collapse.styles');
const { dropdownStyles } = require('./Dropdown/Dropdown.styles');
const { numberInputStyles } = require('./NumberInput/NumberInput.styles');
const { primaryButtonStyles } = require('./Button/PrimaryButton.styles');
const { radioStyles } = require('./Radio/Radio.styles');
const { secondaryButtonStyles } = require('./Button/SecondaryButton.styles');
const { selectInputStyles } = require('./SelectInput/SelectInput.styles');
const { selectionButtonStyles } = require('./SelectionButton/SelectionButton.styles');
const { tagStyles } = require('./Tag/Tag.styles');
const { textButtonStyles } = require('./Button/TextButton.styles');
const { textInputStyles } = require('./TextInput/TextInput.styles');
const { toggleStyles } = require('./Toggle/Toggle.styles');

// Tailwind supports CSS-in-JS syntax, and syntax objects are just
// like normal JS objects, so they can be combined with the spread operator.
const componentStyles = theme => ({
  ...buttonSharedStyles(theme),
  ...checkboxStyles(theme),
  ...circlePrimaryButtonStyles(theme),
  ...circleSecondaryButtonStyles(theme),
  ...collapseStyles(theme),
  ...dropdownStyles(theme),
  ...numberInputStyles(theme),
  ...primaryButtonStyles(theme),
  ...radioStyles(theme),
  ...secondaryButtonStyles(theme),
  ...selectInputStyles(theme),
  ...selectionButtonStyles(theme),
  ...tagStyles(theme),
  ...textButtonStyles(theme),
  ...textInputStyles(theme),
  ...toggleStyles(theme),
});

module.exports = { componentStyles };
